export type ReportTabId = 'shipping' | 'payments';

export interface ReportTab {
  id: ReportTabId;
  labelKey: string;
  icon: string;
}

export const REPORT_TABS: readonly ReportTab[] = [
  { id: 'shipping', labelKey: 'reports.shipping.title', icon: 'fas fa-truck' },
  { id: 'payments', labelKey: 'reports.payments.title', icon: 'fas fa-money-check' },
];

export const REPORT_TAB_IDS: readonly ReportTabId[] = REPORT_TABS.map((tab) => tab.id);

export function toReportTabId(value: string | null | undefined): ReportTabId {
  return REPORT_TAB_IDS.find((id) => id === value) ?? 'shipping';
}
